import { gsap } from '@theme/gsap';
import { ScrollTrigger } from '@theme/gsap-scrolltrigger';
import { HTMLCustomElement } from '@theme/html-custom-element';

class SiteFooter extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      this.refs.image,
      {
        yPercent: -10,
      },
      {
        yPercent: 10,
        ease: 'none',
        scrollTrigger: {
          trigger: this.closest('.shopify-section'),
          scrub: true,
        },
      },
    );
  }
}

if (!customElements.get('site-footer')) customElements.define('site-footer', SiteFooter);
